export const translations = {
  configuracoes: {
    pt: 'Configurações',
    en: 'Settings',
    de: 'Einstellungen',
    es: 'Configuración',
  },
  selecione: {
    pt: 'Selecione...',
    en: 'Select...',
    de: 'Wählen Sie...',
    es: 'Seleccione...',
  },
  novoContato: {
    pt: 'Novo Contato',
    en: 'New Contact',
    de: 'Neuer Kontakt',
    es: 'Nuevo Contacto',
  },
  nome: {
    pt: 'Nome',
    en: 'Name',
    de: 'Name',
    es: 'Nombre',
  },
  telefone: {
    pt: 'Telefone',
    en: 'Telephone',
    de: 'Telefon',
    es: 'Teléfono',
  },
  email: {
    pt: 'Email',
    en: 'Email',
    de: 'Email',
    es: 'Email',
  },
  cancelar: {
    pt: 'Cancelar',
    en: 'Cancel',
    de: 'Abbrechen',
    es: 'Cancelar',
  },
  filtrar: {
    pt: 'Filtrar',
    en: 'Filter',
    de: 'Filtern',
    es: 'Filtrar',
  },
  voltar: {
    pt: 'Voltar',
    en: 'Go back',
    de: 'Zurück',
    es: 'Regresa',
  },
  cadastrar: {
    pt: 'Salvar',
    en: 'Save',
    de: 'Speichern',
    es: 'Salvar',
  },
  transportadora: {
    pt: 'Transportadora',
    en: 'Carrier',
    de: 'Carrier',
    es: 'Transportista',
  },
  area: {
    pt: 'Área',
    en: 'Area',
    de: 'Bereich',
    es: 'Área',
  },
  funcao: {
    pt: 'Função',
    en: 'Role',
    de: 'Rolle',
    es: 'Función',
  },
  removerContato: {
    pt: 'Deseja realmente remover o contato ',
    en: 'Do you really want to remove the contact ',
    de: 'Möchten Sie den Kontakt wirklich entfernen ',
    es: '¿Realmente desea eliminar el contacto ',
  },
  daTransportadora: {
    pt: 'da transportadora',
    en: 'from the carrier',
    de: 'von der Spedition',
    es: 'de la transportista',
  },
};
